import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'

type DetailProps = {
  label: string
  children: React.ReactNode
  /** Native tooltip for the value, e.g. a precise timestamp behind a relative one. */
  title?: string
}

/**
 * A micro-labelled value. The label is small and muted, the value uses the
 * default text colour — this contrast is what lets a dense charge card be
 * scanned by field rather than read as a run-on sentence.
 */
export const Detail = ({ label, children, title }: DetailProps) => (
  <Box>
    <Text
      fontSize={0}
      color="lightText"
      style={{
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Text>
    <Text fontSize={1} title={title} style={{ lineHeight: 1.4 }}>
      {children}
    </Text>
  </Box>
)

type DetailRowProps = {
  children: React.ReactNode
  gap?: number
  mt?: number
}

/** Wrapping row of <Detail> items. */
export const DetailRow = ({ children, gap = 4, mt }: DetailRowProps) => (
  <Flex gap={gap} flexWrap="wrap" alignItems="flex-start" mt={mt}>
    {children}
  </Flex>
)
